import Navbar from "../../features/layout/Navbar";
import Footer from "../../features/layout/Footer";

const PageWrapper = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="overflow-hidden bg-[#f0f0f0]">{children}</div>
      <Footer />
    </>
  );
};

export default PageWrapper;
